let fetchedTime: number | null = null;
let fetchedAt: number | null = null;

export default {
  get(): Promise<number> {
    return new Promise((resolve) => {
      if (!fetchedTime) {
        fetch('//time.akamai.com')
          .then((response) => response.text())
          .then((serverTime) => {
            fetchedTime = parseInt(serverTime, 10) * 1000;
            fetchedAt = Date.now();

            resolve(fetchedTime);
          })
          .catch(() => {
            fetchedTime = Date.now();
            fetchedAt = Date.now();

            resolve(fetchedTime);
          });
      } else {
        resolve(fetchedTime + Date.now() - fetchedAt!);
      }
    });
  },
};
